$('body').on('click', '[data-toggle="cashback-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createCashbackPopup($(this));
}).on('click', '[data-toggle="gift-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createGiftPopup($(this));
}).on('click', '[data-toggle="totalcost-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createTotalCostPopup($(this));
}).on('click', '[data-toggle="deal-builder-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createDealBuilderPopup($(this));
}).on('click', '[data-toggle="imei-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createIMEIPopup($(this));
}).on('click', '[data-toggle="eamc-popup"]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    createEAMCPopup($(this));
});

function createCashbackPopup(el) {
    createModalPopup(
        el,
        $('.cashback-popup'),
        '/ajax/cashback.json',
        ['price-id', 'gift-code', 'tariff-code']
    );
}

function createGiftPopup(el) {
    createModalPopup(
        el,
        $('.cashback-popup'),
        '/ajax/gift.json',
        ['gift-code']
    );
}

function createTotalCostPopup(el) {
    createModalPopup(
        el,
        $('.totalcost-popup'),
        '/ajax/totalcost.json',
        ['price-id']
    );
}

function createIMEIPopup(el) {
    createModalPopup(
        el,
        $('.imei-popup'),
        null,
        []
    );
}

function createEAMCPopup(el) {
    createModalPopup(
        el,
        $('.eamc-popup'),
        '/ajax/eamc.json',
        ['eamc']
    );
}

function createDealBuilderPopup(el) {
    var popup = $('.deal-builder-popup');
    var yes = $('.deal-builder-popup .deal-builder-yes');
    var no = $('.deal-builder-popup .deal-builder-no');
    yes.prop('href', popup.data('url') + el.data('hstarid'));
    no.prop('href', el.prop('href'));
    createModalPopup(
        el,
        popup,
        null,
        []
    );
}

function createModalPopup(el, target, ajaxUrl, optionKeys) {
    var cachedModalHtml = el.data('cached-modal-html');
    var options = {};

    $(optionKeys).each(function(key, val) {
        options[val] = el.data(val);
    });

    if (!ajaxUrl) {
        cachedModalHtml = target.html();
    }
    if (cachedModalHtml) {
        target.html(cachedModalHtml);
        $(target).modal();
        return;
    }
    $.ajax({
        dataType: 'json',
        url: ajaxUrl,
        data: options,
        success: function(data) {
            if (data.success) {
                cachedModalHtml = data.html;
                el.data('cached-modal-html', cachedModalHtml);
                target.html(cachedModalHtml);
                $(target).modal();
            }
        }
    });
}

jQuery(document).ready(function($) {
    switch (window.location.hash) {
        case '#cashback-popup':
            var cashbackPopupLink = $('[data-toggle="cashback-popup"]').first();

            if (cashbackPopupLink.length) {
                createCashbackPopup(cashbackPopupLink);
            }

            break;

        case '#gift-popup':
            var giftPopupLink = $('[data-toggle="gift-popup"]').first();

            if (giftPopupLink.length) {
                createGiftPopup(giftPopupLink);
            }

            break;
    }
});
